export enum DatabaseServiceProvider {
  FIREBASE = "firebase",
}
